import { Button, Input } from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import useRemittanceSettingsForm from "./useRemittanceSettingsForm";

const RemittanceSettingsForm = ({ refetch, closeModal, initialData }) => {
  const { formik } = useRemittanceSettingsForm({
    refetch,
    closeModal,
    initialData,
  });

  return (
    <>
      <div className="pro-w-100">
        <Input
          label={"Advance Payment Percentage"}
          type="text"
          id="advance_payment_percentage"
          name="advance_payment_percentage"
          className={`pro-input lg ${
            formik.errors.advance_payment_percentage &&
            formik.touched.advance_payment_percentage &&
            "error"
          }`}
          {...formik.getFieldProps("advance_payment_percentage")}
          error={
            formik.errors.advance_payment_percentage &&
            formik.touched.advance_payment_percentage
          }
          errorMessage={formik.errors.advance_payment_percentage}
          maxLength={8}
        />

        <Input
          label={"Rate Freeze Duration (Hours)"}
          type="text"
          id="rate_freeze_duration_hours"
          name="rate_freeze_duration_hours"
          className={`pro-input lg ${
            formik.errors.rate_freeze_duration_hours &&
            formik.touched.rate_freeze_duration_hours &&
            "error"
          }`}
          {...formik.getFieldProps("rate_freeze_duration_hours")}
          error={
            formik.errors.rate_freeze_duration_hours &&
            formik.touched.rate_freeze_duration_hours
          }
          errorMessage={formik.errors.rate_freeze_duration_hours}
          maxLength={8}
        />

        <Input
          label={"Service Charge"}
          type="text"
          id="service_charge"
          name="service_charge"
          className={`pro-input lg ${
            formik.errors.service_charge &&
            formik.touched.service_charge &&
            "error"
          }`}
          {...formik.getFieldProps("service_charge")}
          error={
            formik.errors.service_charge && formik.touched.service_charge
          }
          errorMessage={formik.errors.service_charge}
          maxLength={8}
        />
      </div>

      <div className="col-12 pro-d-flex pro-justify-end offcanvas-footer-sticky-btns">
        <Button
          className={"pro-btn-link lg pro-px-5"}
          onClick={() => closeModal()}
        >
          Cancel
        </Button>

        <Button
          className={`pro-btn-primary lg pro-ms-3`}
          type="submit"
          onClick={formik.handleSubmit}
        >
          Update
        </Button>
      </div>
    </>
  );
};

export default RemittanceSettingsForm;
